import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import MDBox from "components/atoms/MDBox";
import MDTypography from "components/atoms/MDTypography";

import { ErrorMessage, Field } from "formik";
import CheckboxGroupWrapper from "components/molecules/Formik/Wrapper/CheckboxGroupWrapper";

function FormCheckboxGroup({
  form,
  field,
  options,
  onChange,
  disabled,
  nameProperty,
  linkProperty,
  ...rest
}) {
  const { values, setFieldValue } = form;
  const value = values[field.name] ? values[field.name] : null;

  // object of {checkbox1name: boolean, checkbox2name: boolean ... } to keep track of each checkbox state
  const [isCheckedState, setIsCheckedState] = useState({});

  useEffect(() => {
    // converting array into object
    const initCheckedState = options.reduce((arr, option) => {
      const stateObj = {};
      if (option) {
        typeof option === "string"
          ? (stateObj[option] = false)
          : (stateObj[option[nameProperty]] = false);
      }
      return { ...arr, stateObj };
    }, {});

    values[field.name].forEach((element) => {
      if (element) {
        typeof element === "string"
          ? (initCheckedState[element] = true)
          : (initCheckedState[element[nameProperty]] = true);
      }
    });

    setIsCheckedState(initCheckedState);
  }, [field.name, nameProperty, options, values]);

  const handleChange =
    onChange ??
    ((e) => {
      isCheckedState[e.target.name] = e.target.checked;

      const selectedAttachments = Object.entries(isCheckedState)
        .filter((entry) => entry[1] === true)
        .map((elem) => {
          return options.find((option) => {
            if (option) {
              if (typeof option === "string") {
                return option === elem[0];
              } else {
                return option[nameProperty] === elem[0];
              }
            } else {
              return false;
            }
          });
        });

      setFieldValue(field.name, selectedAttachments);
    });

  return (
    <MDBox mb={2}>
      <Field
        name={field.name}
        label={field.label}
        value={value}
        state={isCheckedState}
        options={options}
        onChange={handleChange}
        as={CheckboxGroupWrapper}
        disabled={disabled}
        nameProperty={nameProperty}
        linkProperty={linkProperty}
        {...rest}
      />
      <MDBox mt={0.75}>
        <MDTypography
          component="div"
          variant="caption"
          color="error"
          fontWeight="regular"
          sx={{ whiteSpace: "pre-wrap" }}
        >
          <ErrorMessage name={field.name}></ErrorMessage>
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for FormCheckboxGroup
FormCheckboxGroup.propTypes = {
  form: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  options: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  showTitle: PropTypes.bool,
  children: PropTypes.node,
};

export default FormCheckboxGroup;
